export default __webpack_public_path__ + "static/media/misko-hevery.bbe0365f.png";